// import goodsPrice from '@/common/mixins/goodsPrice.js';
import { formatDate } from '@/utils';
import contractComputedMixin from './../../contractComputedMixin.js';
export default {
  mixins: [contractComputedMixin],
  props: {
    // 表单的数据,从中获取公司、供应商、是否勾选
    baseFormData: {
      type: Object,
      default: () => {},
    },
    //是否编辑
    isEdit: {
      type: Boolean,
      default: () => false,
    },
    productData: {
      type: String,
      default: '',
    },
    defaultTableData: {
      type: Array,
      default: () => [],
    },
    detailPageData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      addedTaxRateOptions: [],
      contractStatus: '',
      tableData: [], //表格数据
      isHiddenTopBtn: false,
      orderDetailDelIds: [],
      $filterTableColumn: null,
      isRestrict: null, // 是否定量
      historyTableData: [], // 表格历史数据
    };
  },
  methods: {
    // 插入一行
    async addNewRowHandler() {
      if (!['0', '1'].includes(this.isRestrict) && this.fileType == 'contract') {
        this.$message.error('请先选择是否定量');
        return;
      }
      // const indexNo = this.getTableData().length;
      // const contractDetailNo = indexNo + 1;
      const $table = this.$refs.xTableRef;
      const record = {
        // contractDetailNo,
        priceConfirmDate: new Date(),
        // productQuantity: '10000',
        isFixedPrice: this.fileType == 'agreement' ? '0' : 0,
        productQuantity: this.fileType == 'agreement' ? null : this.isRestrict == 0 ? '0' : null,
      };
      const { row } = await $table.insertAt(record, 0);
      console.log('插入数据');
      this.$emit('isDisabledIsRestrict', true);
      await $table.setActiveRow(row);
    },
    // 正常编辑的选中
    handleChange(row, field) {
      console.log(row, field, '修改表格行');
      if (
        field === 'productQuantity' ||
        field === 'businessContractUnitPrice' ||
        field == 'businessContractTaxAmount' ||
        field == 'businessChangeUnitPrice' ||
        field == 'taxRate'
      ) {
        if (field === 'taxRate') {
          if (row['taxRate'] > 1 || row['taxRate'] < 0) {
            this.$message.error('增值税只能是0-1之间的数值');
            row['taxRate'] = 0;
          }
        }
        // row['businessContractTotalAmount'] = (
        //   row['productQuantity'] * row['businessContractUnitPrice']
        // ).toFixed(2);
        // // 净值计算
        // row['businessContractPureAmount'] =
        //   row['businessContractTotalAmount'] - row['businessContractTaxAmount'];
        // // 变动价税合计
        // const businessChangeTotalAmount = (
        //   row['productQuantity'] * row['businessChangeUnitPrice']
        // ).toFixed(2);
        // row['businessChangeTotalAmount'] =
        //   businessChangeTotalAmount == 'NaN' ? 0 : businessChangeTotalAmount;
        // // 变动价格净值
        // row['businessChangePureAmount'] =
        //   row['businessChangeTotalAmount'] - row['businessChangeTaxAmount'];
        console.log('开始修改');
        // 变动单价
        row['businessContractTotalAmount'] = this.computedBusinessContractTotalAmount(row); // 价税合计金额
        row['businessContractPureAmount'] = this.computedBusinessContractPureAmount(row); // 净值
        row['variablePrice'] = row['businessContractUnitPrice'];
        row['businessChangeUnitPrice'] = row['businessContractUnitPrice'];
        row['productQuantity2'] = row['productQuantity']; // 销售数量等于采购数量
        row['productQuantity1'] = row['productQuantity']; // 交货数量等于采购数量
        row['businessChangeTaxAmount'] = row['businessContractTaxAmount'];
        row['businessChangeTotalAmount'] = this.computedBusinessChangeTotalAmount(row); // 变动单价中 - 价税合计金额
        row['businessContractTaxAmount'] = this.computedBusinessContractTaxAmount(row); // 税额
        row['businessChangeTaxAmount'] = this.computedBusinessChangeTaxAmount(row); // 变动单价中 - 税额
        // row['businessChangePureAmount'] = this.computedBusinessChangePureAmount(row); // 变动单价中 - 净值
        row['businessChangePureAmount'] =
          row['businessChangeTotalAmount'] - row['businessChangeTaxAmount']; // 变动单价中 - 净值
      } else if (field == 'isFixedPrice') {
        // 是否定价，如果选择否就表单中勾选
        row['priceIdentity'] = row['isFixedPrice'];
        // if (row['isFixedPrice'] == '0') {
        //   // 给价格标识赋值
        //   row['priceIdentity'] = '未定价';
        // } else {
        //   row['priceIdentity'] = '已定价';
        // }
      }
    },
    // 选择商品
    chooseTable(val, row, field) {
      console.log(val, row, field);
      const rowData = val[0];
      console.log(JSON.stringify(rowData), '选中的数据');
      if (!Object.keys(rowData).length) return;
      if (field === 'productDesc') {
        const product = val[0];
        if (this.tradeType == 'MY04' || this.tradeType == 'MY03' || this.tradeType == 'MY02') {
          if (product.customsId == null) {
            // this.orderDetailDelIds.push(row.id)
            //this.$refs.xTable.remove(row);
            // //设置定价或不定价
            //该商品没有海关信息请维护
            this.$message({
              type: 'error',
              message: '该商品没有海关信息请维护',
            });
            this.setFixedPrice();
            this.editClosedEvent({ row });
            this.$emit('clearValidate');
            return;
          }
        }
        //如果没有选产品 则不走下面的逻辑
        if (product) {
          console.log(product.basicUnit, product.basicUnitName, '---->>>>');
          console.log(product.businessContractTaxAmount, '税额');
          row.productNo = product.parentProductNo;
          row.productDesc = product.productChName;
          row.unit = product.basicUnit || null;
          row.unitName = product.basicUnitName || null;
          row.customsId = product.customsId || null;
          row.taxRate = product.valueAddedTaxRate || 0;
          row.taxCode =
            this.$route.query.contractCategory == 'sales'
              ? product.salesTaxCode
              : product.valueAddedTaxCode;
          row.taxName = row.taxCode
            ? this.addedTaxRateOptions.find((options) => {
                return row.taxCode == options.taxCode;
              }).taxName
            : '';
          row.valueAddedTaxRate = product.salesTaxRate || null;
          // 进口普通关税率
          row.importNormalTariffRate = product.importNormalTariffRate || null;
          // 单独处理生成销售合同时候的合同标
          row.contractMatter = rowData?.parentProductNo;
          row.contractMatterName = rowData?.productChName;
          //出口 转口 税率取出口退税率   其他是消费税率
          if (this.tradeType != '') {
            if (this.$route.query.contractCategory == 'sales') {
              row.consumptionTaxRate = product.salesTaxRate;
              row.taxRefundRate = product.taxRefundRate;
              row.taxRate = product.salesTaxRate;
              //销售-- 销项税码
              if (this.tradeType == 'MY04' || this.tradeType == 'MY03') {
                row.consumptionTaxRate = 0;
                //销售 -出口  04 转口 03 // 采购 -进口02
              }
            } else {
              row.valueAddedTaxRate = product.valueAddedTaxRate;
              row.taxRate = product.valueAddedTaxRate;
              //采购 --进项税码
              if (this.tradeType == 'MY03' || this.tradeType == 'MY02') {
                row.valueAddedTaxRate = 0;
                //采购 -转口 -进口02
                row.importNormalTariffRate = product.importNormalTariffRate; //importNormalTariffRate
              }
            }
          }
          console.log(JSON.stringify(row), '当前行数据');
          row['businessContractPureAmount'] = this.computedBusinessContractPureAmount(row); // 净值
          row['businessContractTaxAmount'] = this.computedBusinessContractTaxAmount(row); // 税额
          row['businessContractTotalAmount'] = this.computedBusinessContractTotalAmount(row); // 价税合计金额
          row['businessChangeTotalAmount'] = this.computedBusinessChangeTotalAmount(row); // 变动单价中 - 价税合计金额
          // row['businessChangePureAmount'] = this.computedBusinessChangePureAmount(row); // 变动单价中 - 净值
          row['businessChangeTaxAmount'] = this.computedBusinessChangeTaxAmount(row); // 变动单价中 - 税额
          row['businessChangePureAmount'] =
            row['businessChangeTotalAmount'] - row['businessChangeTaxAmount']; // 变动单价中 - 净值
        }
      } else if (field == 'storageName') {
        // 如果是仓库的时候  storageCode  storageName
        row['storageNo'] = rowData?.storageCode;
        row['storageName'] = rowData?.storageName;
      }
    },
    // 删除
    deleteBtnClickHandler() {
      if (!this.selectionList.length) {
        this.$message.error('请选择行操作');
        return;
      }
      const XIDList = this.selectionList.map((item) => item._XID);
      this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
      // 判断当前删除中是否有id
      const idList = this.selectionList.map((item) => item.id);
      this.orderDetailDelIds.push(...idList); // 全部被删除的id
      // 汇总数据
      this.$emit('closeTableHandler', this.tableData);
      // 全部删除的时候恢复可以改限数
      if (this.tableData.length == 0) {
        this.$emit('isDisabledIsRestrict', false);
      }
    },
    // 选择行
    handleSelectionChange(row) {
      this.selectionList = row.selection;
    },
    // 关闭的时候数据校验
    closeEditTableHandler() {
      console.log(this.getTableData(), '?1111??');
      // const $table = this.$refs.xTableRef;
      // const errMap = await $table.validate().catch((errMap) => errMap);
      // if (errMap) {
      //   this.$message.error('请检查数据再提交');
      // } else {
      //   await $table.clearActived();
      //   // 派发事件更新表单数据
      //   this.$emit('closeTableHandler', this.getTableData());
      // }
      this.$emit('closeTableHandler', this.getTableData());
    },
    // 简单获取表格数据
    getTableData() {
      const $table = this.$refs.xTableRef;
      return $table.getTableData().fullData;
    },
    // 获取表格数据并且校验
    getValidateTableData() {
      // this.closeEditTableHandler();
      return new Promise((resolve, reject) => {
        const $table = this.$refs.xTableRef;
        const tableData = $table.getTableData().fullData;
        $table.validate((valid) => {
          if (valid && tableData.length) {
            const newData = tableData.map((item, index) => {
              if (this.isRestrict == '1' && item.productQuantity == 0) {
                this.$message.error('当前属于限购，采购数量不能为0');
                reject({ orderDetailList: [], orderDetailDelIds: [] });
                return {};
              }
              return {
                ...item,
                priceConfirmDate: item.priceConfirmDate ? formatDate(item.priceConfirmDate) : null,
                businessChangeUnitPrice: item.variablePrice,
                variablePrice: null,
                contractDetailNo: index + 1,
                taxRate: item.taxRate ? item.taxRate : 0,
                isFixedPrice: ['0', '1'].includes(item.isFixedPrice)
                  ? +item.isFixedPrice
                  : item.isFixedPrice,
              };
            });
            // 获取历史表格的id
            const historyTableIds = this.historyTableData.map((item) => item.id);
            resolve({
              orderDetailList: newData,
              orderDetailDelIds: [...this.orderDetailDelIds, ...historyTableIds],
            });
          } else {
            this.$message.error('请填写表格数据');
            reject({ orderDetailList: [], orderDetailDelIds: [] });
          }
        });
      });
    },
    // 重置表格
    resetTable() {
      // 保存当前行id，提交的时候当做删除
      this.historyTableData = [
        ...this.historyTableData,
        ...this.$refs.xTableRef.getTableData().fullData,
      ];
      console.log('重置表格数据', this.historyTableData);
      this.tableData = [];
    },

    _getTaxRateList() {
      this.$baseRequest.getTaxRate({}).then((result) => {
        this.addedTaxRateOptions = result;
      });
    },
    _judgeSupplierType(isRelatedParty, partnerType, ifPersonalPartner) {
      console.log(
        `判断当前供应商类型===>>>是否关联方:${isRelatedParty},供应商:${partnerType}, 是否个人合作伙伴:${ifPersonalPartner}`
      );
      // 内部
      if (isRelatedParty == 'Y') {
        return 'INTERNAL_SETTLEMENT';
      }
      if (partnerType == 'HZHB02' && ifPersonalPartner == '1' && isRelatedParty == 'N') {
        // 投送人
        return 'DROP_OFF_PERSON';
      }
      // 外部
      return 'WITHOUT_SETTLEMENT';
    },
    // 根据后端数据反填数据到表格中
    fullTableData(val) {
      if (val && Array.isArray(val) && val.length) {
        this.tableData = val.map((item) => {
          return {
            ...item,
            productQuantity1: item.productQuantity,
            productQuantity2: item.productQuantity,
            variablePrice: item.businessChangeUnitPrice,
            businessChangePureAmount: item.businessChangePureAmount,
            businessChangeTaxAmount: item.businessContractTaxAmount,
          };
        });
      } else {
        this.tableData = [];
      }
    },
  },
  mounted() {
    this._getTaxRateList();
  },
  watch: {
    defaultTableData: {
      handler(val) {
        this.fullTableData(val);
      },
      immediate: true,
    },
    // 监听表单组件的值来过滤表格字段
    baseFormData: {
      handler(val) {
        console.log(val, '?????===?>');
        if (this.$filterTableColumn) {
          clearTimeout(this.$filterTableColumn);
        }
        this.$filterTableColumn = setTimeout(() => {
          this.filterTableColumn(val);
        });
      },
      immediate: true,
      deep: true,
    },
    'baseFormData.isRestrict': {
      handler(val) {
        console.log(val, '监听是否限价');
        this.isRestrict = val;
        // this.tableData = []; // 清空数据
      },
      immediate: true,
    },
  },
};
